export const IMAGE_1 = require('./5_image_1.png'); 
export const IMAGE_2 = require('./5_image_2.png');
export const IMAGE_3 = require('./5_image_3.png');
export const IMAGE_4 = require('./5_image_4.png');
export const IMAGE_5 = require('./5_image_5.png');
export const LEFT_ARROW = require('./left_arrow.png'); 
export const RIGHT_ARROW = require('./right_arrow.png'); 
export const PAGER = require('./4_pager.png'); 
export const PAGER_ACTIVE = require('./4_pager2.png'); 
